module.exports = __webpack_public_path__ + "static/media/tw_wco.9209056e.png";